import { render, staticRenderFns } from "./AbatementDistribution.vue?vue&type=template&id=30f64b8f&"
import script from "./AbatementDistribution.vue?vue&type=script&lang=js&"
export * from "./AbatementDistribution.vue?vue&type=script&lang=js&"
import style0 from "./AbatementDistribution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VApp,VBtn,VContainer,VFadeTransition})
